import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Flyout, FlyoutActions, FlyoutContent, FlyoutHeader } from '@ravago/shared/radiance/components/flyout/components/Flyout/Flyout';
import { useTranslations } from '@ravago/shared/translations/client';

import { ProductPriceCardItem } from '../models/product-price-card-item.model';
import { ProductPriceListFiltersValue } from '../models/product-price-list-filters-value';

import { ProductPriceListFilterFields } from './product-price-list-filter-fields';

interface Props {
   open: boolean;
   productPriceCardItems: ProductPriceCardItem[];
   value: ProductPriceListFiltersValue;
   onChange: (value: ProductPriceListFiltersValue) => void;
   onClear: () => void;
   onClose: () => void;
}

export const ProductPriceListFilterFlyout = ({ open, productPriceCardItems, value, onChange, onClear, onClose }: Props) => {
   const translate = useTranslations();

   return (
      <Flyout open={open} position="right" onFlyoutClose={onClose} closeOnOutsideClick>
         <FlyoutHeader>{translate('filter.filters')}</FlyoutHeader>

         <FlyoutContent>
            <Box direction="column" gap="md">
               <ProductPriceListFilterFields productPriceCardItems={productPriceCardItems} value={value} onChange={onChange} />
            </Box>
         </FlyoutContent>

         <FlyoutActions>
            <Button variant="secondary" onClick={onClear} fullWidth>
               {translate('filter.clear-all-filters')}
            </Button>
            <Button variant="primary" onClick={onClose} fullWidth>
               {translate('filter.show-results')}
            </Button>
         </FlyoutActions>
      </Flyout>
   );
};
